import React, { useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import SideBar from "./components/sidebar/SideBar";
import WebLogin from "./pages/login/WebLogin";
import Register from "./pages/register/Register";
import Verify from "./pages/verify/Verify";
import Dashboard from "./pages/dashboard/Dashboard";
import ProgramsDash from "./pages/programsdash/ProgramsDash";
import QuestionnaireDash from "./pages/questionnairedash/QuestionnaireDash";
import ReportsDash from "./pages/reportsdash/ReportsDash";
import SettingsDash from "./pages/settingsdash/SettingsDash";
import ProgramsDetails from "./pages/programsdetails/ProgramsDetails";
import ExerciseBuilder from "./pages/exercisebuilder/ExerciseBuilder";
import VirtualBuilder from "./pages/virtualbuilder/VirtualBuilder";
import QuestionnaireBuilder from "./pages/questionnairebuilder/QuestionnaireBuilder";
import PatientAssessment from "./pages/patientassessment/PatientAssessment";
import Questionare from "./pages/questionare/Questionare";
import LandingPage from "./pages/landingpage/LandingPage";
import CustomQuestionnaire from "./pages/customquestionnaire/CustomQuestionnaire";
import PatientsList from "./pages/patientslist/PatientsList";
import PatientDetails from "./pages/patientdetails/PatientDetails";
import Messages from "./pages/messages/Messages";
import CloudNotifications from "./pages/notifications/CloudNotifications";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import VerifyLink from "./pages/verifylink/VerifyLink";
import VerifyPhone from "./pages/verifyphone/VerifyPhone";
import ResetPassword from "./pages/resetpassword/ResetPassword";
import PatientLogin from "./pages/patient_login/PatientLogin";
import PatientSettings from "./components/patientsettings/PatientSettings";
import VirtualActivities from "./pages/virtual_activities/VirtualActivities";
import WorkoutsDash from "./pages/workoutsdash/WorkoutsDash";
import WorkoutDetails from "./pages/workoutsDetails/WorkoutDetails";
import SignUpFlow from "./pages/signupflow/SignUpFlow";
import AddNewMember from "./components/addNewMember/AddNewMember";
import Clients from "./pages/companyclients/Clients";
import AddNewClient from "./components/addNewClient/AddNewClient";
import VerifyAdminPassword from "./pages/verifyadmin/VerifyAdminPassword";
import TherapistRegister from "./pages/therapistregister/TherapistRegister";
import Unsubscribe from "./pages/unsubscribe/Unsubscribe";
import AppLaunchPage from "./pages/applaunchpage/AppLaunchPage";

import Companylanding from "./pages/companylanding/Companylanding";

import CareTeam from "./components/careTeam/CareTeam";

import AddPtForm from "./components/addptform/AddPtForm";
import { ContextProvider } from "./context/Context";
import InternetStatusOverlay from "./components/internetstatusverlay/InternetStatusOverlay";
import { Toaster } from "react-hot-toast";
import PatientRegister from "./pages/patientRegister/PatientRegister";
import MobileUploadPage from "./pages/patientRegister/MobileUploadPage";
import { ProgramContextProvider } from "./context/ProgramsContext";
import NewProgramDetails from "./pages/newProgramDetails/NewProgramDetails";
import AnalyticsPageTabs from "./pages/analytics/AnalyticsPageTabs";
import ReportPanel from "./pages/report-panel/reportPanel";

function App() {
  const [sidebarVisible, setSidebar] = useState(false);
  //let navigate = useNavigate();

  const actSidebar = (bool) => {
    setSidebar(bool);
  };

  const [isLogged, setLogged] = useState(!!localStorage.getItem("userData"));
  const checkLoggedIn = (loggedInValue) => {
    setLogged(loggedInValue);
  };

  const isSuperAdmin =
    localStorage.getItem("userData") &&
      JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;

  const isCompanyAdmin =
    localStorage.getItem("userData") &&
      JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;

  const isTherapist =
    localStorage.getItem("userData") &&
      JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).user_type === 2
        ? true
        : false
      : false;
  return (
    <div className="App">
      <ContextProvider>
        <InternetStatusOverlay />
        {sidebarVisible && isLogged && (
          <SideBar checkLoggedIn={checkLoggedIn} />
        )}
        <div
          className={
            sidebarVisible ? "content_holder" : "content_holder_no_sidebar"
          }
        >
          <Routes>
            <Route
              path="/login"
              element={
                <PatientLogin
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/dashboard"
              element={
                isLogged && isTherapist ? (
                  <Dashboard
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/programs"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/workouts"
              element={
                isLogged && isTherapist ? (
                  <WorkoutsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/myPatients"
              element={
                isLogged && isTherapist ? (
                  <PatientsList
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/messages"
              element={
                isLogged && isTherapist ? (
                  <Messages
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/reports"
              element={
                isLogged && isTherapist ? (
                  <ReportsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/reports/:tab2"
              element={
                isLogged && isTherapist ? (
                  <ReportsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/questionnaires"
              element={
                isLogged && isTherapist ? (
                  <QuestionnaireDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/clients"
              element={
                isSuperAdmin ? (
                  <Clients
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />

            <Route
              path="/settings"
              element={
                isLogged ? (
                  <SettingsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/notifications"
              element={
                isLogged && isTherapist ? (
                  <CloudNotifications
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route
              path="/ptlogin"
              element={
                <WebLogin
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/signup"
              element={
                <SignUpFlow
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/verify"
              element={
                <Verify actSidebar={actSidebar} checkLoggedIn={checkLoggedIn} />
              }
            />

            <Route
              path="/forgotpassword"
              element={
                <ForgotPassword
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/phone_login"
              element={
                <VerifyPhone
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            {/* <Route
              path="/newprogram"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDetails
                    actSidebar={actSidebar}
                    newTemplate={undefined}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            /> */}


            <Route
              path="/newprogram"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            
            <Route
              path="/newprogram/:patientId/:patientName"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/newworkout"
              element={
                isLogged && isTherapist ? (
                  <WorkoutDetails
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/newworkout/:id"
              element={
                isLogged && isTherapist ? (
                  <WorkoutDetails
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            {/* #EXTRA PATH */}
            <Route
              path="/messages/:id"
              element={
                isLogged && isTherapist ? (
                  <Messages
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/programs/:tab2"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDash
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/reset-password/:verify_mail"
              element={
                <ResetPassword
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            {/* <Route
              path="/newtemplate"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDetails
                    actSidebar={actSidebar}
                    newTemplate={true}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            /> */}

            <Route
              path="/landing"
              element={
                isLogged ? (
                  <LandingPage
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/add-new-member"
              element={
                (isCompanyAdmin || isSuperAdmin) && isLogged ? (
                  <AddNewMember
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route path="/applaunch" element={<AppLaunchPage />} />

            <Route
              path="/add-new-client"
              element={
                isLogged && isSuperAdmin ? (
                  <AddNewClient
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/edit-client/:id"
              element={
                (isCompanyAdmin || isSuperAdmin) && isLogged ? (
                  <AddNewClient
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/tasks/:task_id"
              element={
                isLogged && isTherapist ? (
                  <ExerciseBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/add-new-therapist"
              element={
                (isCompanyAdmin || isSuperAdmin) && isLogged ? (
                  <AddPtForm
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/virtual_activities"
              element={
                isLogged && isTherapist ? (
                  <VirtualActivities
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />


            <Route
              path="/new_patient_intake"
              element={
                <PatientRegister
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />
            <Route
              path="/upload/:sessionId/:documentType"
              element={
                <MobileUploadPage
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/register"
              element={
                <Register
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/register-practice/:patientCode"
              element={
                <Register
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/virtual_builder"
              element={
                isLogged && isTherapist ? (
                  <VirtualBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/virtual_builder/:id"
              element={
                isLogged && isTherapist ? (
                  <VirtualBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            {/* <Route
              path="/details/:id"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDetails
                    actSidebar={actSidebar}
                    newTemplate={undefined}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            /> */}
            <Route
              path="/details/:id"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            {/* <Route
              path="/details/:id/:edit"
              element={
                isLogged && isTherapist ? (
                  <ProgramsDetails
                    actSidebar={actSidebar}
                    newTemplate={undefined}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            /> */}
            <Route
              path="/details/:id/:edit"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/initial_questionare"
              element={isLogged ? <Questionare /> : <Navigate to="/" />}
            />

            <Route
              path="/questionnaire_builder"
              element={
                isLogged && isTherapist ? (
                  <QuestionnaireBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/questionnaire_builder/:id"
              element={
                isLogged && isTherapist ? (
                  <QuestionnaireBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/edit-member/:id"
              element={
                (isCompanyAdmin || isSuperAdmin) && isLogged ? (
                  <AddNewMember
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/edit-patient-details/:userid"
              element={
                <PatientSettings
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/patient_assessment/:id"
              element={
                isLogged && isTherapist ? (
                  <PatientAssessment
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route path="/unsubscribe/:code/:title" element={<Unsubscribe />} />

            {/* __________________________________ */}

            <Route
              path="/verify-link/:verify_mail/:verify_code"
              element={
                <VerifyLink
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/patient-details/:id/:program_id"
              element={
                isLogged && isTherapist ? (
                  <PatientDetails
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route path="/nevellgroup" element={<Companylanding />} />

            <Route
              path="/tasks/newtask/:dayInx/:taskInx"
              element={
                isLogged && isTherapist ? (
                  <ExerciseBuilder
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/verify-account-password/:firstName/:lastName/:email/:companyId/:businessId/:code"
              element={
                <VerifyAdminPassword
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />

            <Route
              path="/add-care-team/:id/:program_id"
              element={
                isLogged && isTherapist ? (
                  <CareTeam
                    actSidebar={actSidebar}
                    checkLoggedIn={checkLoggedIn}
                  />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/patient-assesment/:id/:pid/:prid"
              element={
                <CustomQuestionnaire
                  isLogged={isLogged}
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                  haveBack={true}
                />
              }
            />

            <Route
              path="/questionnaire/:id"
              element={
                <CustomQuestionnaire
                  isLogged={isLogged}
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                  haveBackToLanding={isTherapist ? false : true}
                  isTherapist={isTherapist}
                />
              }
            />

            <Route
              path="/ptregister/:firstName/:lastName/:email/:businessId/:code"
              element={
                <TherapistRegister
                  actSidebar={actSidebar}
                  checkLoggedIn={checkLoggedIn}
                />
              }
            />



            {/* =================== NEW PROTOCOL ROUTES ============ */}

            <Route
              path="/newtemplate"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            
            <Route
              path="/protocols/:id"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/protocols/:id/:edit"
              element={
                isLogged && isTherapist ? (
                  <ProgramContextProvider>
                    <NewProgramDetails
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                  </ProgramContextProvider>
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            <Route
              path="/analytics"
              element={
                isLogged && isTherapist ? (
                    <AnalyticsPageTabs
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route
              path="/report-panel"
              element={
                isLogged && isTherapist ? (
                    <ReportPanel
                      actSidebar={actSidebar}
                      newTemplate={undefined}
                      checkLoggedIn={checkLoggedIn}
                    />
                ) : (
                  <Navigate to="/" />
                )
              }
            />

            {/* ____________________________________________________________________________________ */}

          </Routes>
        </div>
        <Toaster />
      </ContextProvider>
    </div>
  );
}

export default App;